"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imColors = void 0;
/* eslint-disable sort-keys */

var imColors = exports.imColors = {
  black: '#333',
  black900: '#131313',
  // 900 opacity
  black800: '#333333',
  // 800 opacity
  black700: '#515151',
  // 700 opacity
  black600: '#6B6B6B',
  // 600 opacity
  black500: '#8B8B8B',
  // 500 opacity
  black400: '#00000066',
  // 40% opacity, used for overlay
  black300: '#C4C4C4',
  // 300 opacity
  black260: '#3333333d',
  // 26% opacity, used for box shadow
  black200: '#E3E3E3',
  // 200 opacity
  black100: '#EEEEEE',
  // 100 opacity
  black50: '#F7F7F7',
  // 50 opacity
  black40: '#9FB1C4',
  // 40 opacity
  black35: '#C9D1DA',
  // 35 opacity
  black25: '#F2F5F8',
  // 25 opacity
  black10: '#F8F8F8',
  // 10 opacity
  white: '#fff',
  darkGrey: '#646464',
  mediumGrey: '#D1D1D1',
  lightGrey: '#F8F8F8',
  /** primary */
  darkBlue: '#0164B0',
  blue: '#0077D4',
  blue400: '#8AC4E5',
  mediumBlue: '#4198EE',
  light1Blue: '#C0DFF8',
  light2Blue: '#E6F2FC',
  lighterBlue: '#F9FCFE',
  light50Blue: '#F3FAFF',
  /** success */
  darkGreen: '#054F31',
  green: '#18846F',
  mediumGreen: '#A6F4C5',
  lightGreen: '#E3FFFA',
  lighterGreen: '#F6FEF9',
  /** error */
  darkRed: '#7A271A',
  red: '#B11616',
  mediumRed: '#D92D20',
  light1Red: '#FEE4E2',
  light2Red: '#FEF3F2',
  lighterRed: '#FFFCFC',
  /** attention */
  darkPorcupine: '#7A2E0E',
  porcupine: '#936900',
  mediumPorcupine: '#DC6803',
  light1Porcupine: '#FEF0C7',
  light2Porcupine: '#FFFAEB',
  lighterPorcupine: '#FFFEF9',
  /** rose */
  darkRose: '#89123E',
  rose: '#C01048',
  lightRose: '#E31B54',
  /** purple */
  purple50: '#F4F3FF',
  purple100: '#EBE9FE',
  purple200: '#C7BAE9',
  purple300: '#AC98DE',
  purple400: '#807AC6',
  purple500: '#8669CF',
  purple600: '#7A5AF8',
  purple700: '#6938EF',
  purple800: '#4A1FB8',
  purple900: '#3E1C96',
  /** pink */
  pink50: '#FDF2FA',
  pink100: '#F1C0DB',
  pink700: '#AE2671',
  pink800: '#C22C76',
  pink900: '#8A1E67',
  /** indigo */
  indigo50: '#EEF4FF',
  indigo100: '#E0EAFF',
  indigo200: '#C7D7FE',
  indigo600: '#444CE7',
  indigo700: '#3538CD',
  indigo800: '#2D31A6',
  indigo900: '#2D3282'
};